import React, { useState } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { Form, Field } from 'react-final-form';

import {
  required,
  isPhoneNumber,
  composeValidators,
} from '../../utils/formValidators';
import FormField from '../Form/FormField';
import 'assets/scss/components/report-config.css';

const SmsNumberField = ({ updateAlertPhoneNumber, sms_alert_number }) => {
  const [isEditing, toggleEdit] = useState(false);
  const onSubmit = ({ smsAlertNumber }) => {
    toggleEdit(false);
    updateAlertPhoneNumber(smsAlertNumber);
  };

  return (
    <React.Fragment>
      <Form
        inline
        onSubmit={onSubmit}
        initialValues={{ smsAlertNumber: sms_alert_number }}
        render={({ handleSubmit, form, submitting }) => (
          <form
            name="customSurveyEditForm"
            className="soono-form"
            onSubmit={handleSubmit}
          >
            <label>Send SMS Notifications to:</label>
            <div className="input-group align-items-center">
              <FormField
                name="smsAlertNumber"
                containerClassName="col-md-6 p-0"
                inputClassName="form-control"
                disabled={!isEditing}
                validate={composeValidators(required, isPhoneNumber)}
              />

              {isEditing && (
                <div className="input-group-append">
                  <button
                    type="button"
                    className="save-btn inline-btn"
                    onClick={handleSubmit}
                    disabled={submitting}
                  >
                    <FontAwesomeIcon className="mr-0" icon="check" />
                  </button>
                  <button
                    onClick={() => {
                      form.reset();
                      toggleEdit(false);
                    }}
                    type="button"
                    className="cancel-btn inline-btn"
                  >
                    <FontAwesomeIcon className="mr-0" icon="times" />
                  </button>
                </div>
              )}
              {!isEditing && (
                <div className="input-group-append">
                  <button
                    className="edit-btn inline-btn"
                    type="button"
                    onClick={() => toggleEdit(true)}
                  >
                    <FontAwesomeIcon className="mr-0" icon="pencil-alt" />
                  </button>
                </div>
              )}
            </div>
          </form>
        )}
      />
    </React.Fragment>
  );
};

export default SmsNumberField;



// WEBPACK FOOTER //
// ./src/components/emailConfig/SmsNumberField.js